var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    width: "14px",
    height: "14px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 13.6667C3.31804 13.6667 0.333374 10.682 0.333374 7.00004C0.333374 3.31804 3.31804 0.333374 7.00004 0.333374C10.682 0.333374 13.6667 3.31804 13.6667 7.00004C13.6667 10.682 10.682 13.6667 7.00004 13.6667ZM7.00004 12.3334C8.41453 12.3334 9.77108 11.7715 10.7713 10.7713C11.7715 9.77108 12.3334 8.41453 12.3334 7.00004C12.3334 5.58555 11.7715 4.229 10.7713 3.2288C9.77108 2.22861 8.41453 1.66671 7.00004 1.66671C5.58555 1.66671 4.229 2.22861 3.2288 3.2288C2.22861 4.229 1.66671 5.58555 1.66671 7.00004C1.66671 8.41453 2.22861 9.77108 3.2288 10.7713C4.229 11.7715 5.58555 12.3334 7.00004 12.3334ZM10.2607 4.68204L4.68204 10.2607C4.31762 10.001 3.99904 9.68246 3.73937 9.31804L9.31804 3.73937C9.68246 3.99904 10.001 4.31762 10.2607 4.68204Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.84012c2465d4ca2154f6dac41382783f.svg";
export { ForwardRef as ReactComponent };